import {
  useAddRawCacheTagHeader,
  useAddServiceCacheTagHeader,
} from '@backmarket/nuxt-module-http-cache/composables/useAddCacheTagHeader'

import { useFetchFormattedCMSSections } from '~/scopes/cms/composables/useFetchFormattedCMSSections'
import { useAddSectionsCacheTagHeader } from '~/scopes/cms/composables/useSetCMSPageCacheTagHeader'
import { useFetchPickers } from '~/scopes/product-core/composables/useFetch/useFetchPickers/useFetchPickers'

// Set cache Header for Cloudflare
export function useAddCacheTags() {
  useAddServiceCacheTagHeader()

  const { data: pickersResponse } = useFetchPickers()

  // Pass a getter (not the resolved value): the pickers response is fetched
  // with `useAsyncData` and is still empty here, so reading `.value` now would
  // hand over `undefined`. `useAddRawCacheTagHeader` watches the getter and
  // appends the raw Cache-Tag header once the request resolves, before the SSR
  // response is sent. No-op on the client.
  //
  // The getter resolves to `undefined` (never an empty string) so we never
  // forward an empty value: the pickers field is `''` when the upstream
  // response carries no Cache-Tag header. Must stay a getter — guarding the
  // call synchronously would skip the watcher while the value is still empty.
  useAddRawCacheTagHeader(
    () => pickersResponse.value?.pickersResponseCacheTagHeader,
  )

  const { data: cmsSections } = useFetchFormattedCMSSections({
    timeout: 2000,
  })
  // Getter, not the resolved value: `cmsSections` is an un-awaited `useAsyncData`
  // here (the Mod PDP page doesn't pre-fetch it), so `.value` is still empty at
  // this synchronous point. `useAddSectionsCacheTagHeader` watches the getter and
  // sets the tag once the sections resolve, before the SSR response is sent.
  useAddSectionsCacheTagHeader(() => cmsSections.value?.id)
}
